export const getExportRow = (mission, hours = 3) => ({
  'Collaborateur': `${mission.user.firstName} ${mission.user.lastName}`,
  'Numéro de Registre national': mission.user.businessNumber,
  'Date': new Date(mission.dateTime).toLocaleDateString(),
  'Reference': mission.client.name,
  'Montant': `€${mission.surgePayout / 3}`,
  'Heures': hours,
  'KM ABO Sociale': '-',
  'Lieu': mission.cityPlan.city.name,
  'Pays': 'Be',
  'Fonction': '681',
  'Statut': 'Stu',
})

export const getRows = missions => {
  const groupedMissions = missions.reduce((acc, mission) => {
    const date = new Date(mission.dateTime).toLocaleDateString()
    acc[mission.user.id] = {
      ...(acc[mission.user.id] || {}),
      [date]: [...((acc[mission.user.id] || {})[date] || []), mission],
    }
    return acc
  }, {})

  return Object.keys(groupedMissions).reduce((acc, userId) => {
    const userMissions = groupedMissions[userId]
    Object.keys(userMissions).forEach(day => {
      const missions = userMissions[day]
      acc.push(getExportRow(missions[0], missions.length * 3))
    })
    return acc
  }, [])
}



// WEBPACK FOOTER //
// ./src/Components/ExportRoster/util.js